import * as api from '../api';

// set token in redux store
export const SET_DAILY_VIDEO = 'SET_DAILY_VIDEO';
export const setDailyVideo = (video) => {
  return {
    type: SET_DAILY_VIDEO,
    video
  };
};

export const GET_DAILY_VIDEO = 'GET_DAILY_VIDEO';
export const getDailyVideo = () => (dispatch) => {
  api.getDailyVideo()
    .then(video => {
      dispatch(setDailyVideo(video));
      return video;
    });
};



// WEBPACK FOOTER //
// ./src/actions/dailyVideo.js